import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";

// Kuitwa kwa PageHero Component
import PageHero from "../ones/PageHero";

// Kuimport picha za kurasa na background ya Hero
import savingsHeroBg from '../assets/image23.jpeg';
import hisaImg from '../assets/image24.jpeg';
import akibaImg from '../assets/image25.jpeg';
import amanaImg from '../assets/image26.jpeg';

import { FaChartLine, FaPiggyBank, FaShieldAlt, FaRegGem, FaAward } from "react-icons/fa";
import { IoMdCheckmarkCircle } from "react-icons/io";

export default function SavingsDepositsDetailed(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initializations zote hapa
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="ycsc-savings-detailed-page animate__animated animate__fadeIn">
                
                {/* 1. HERO BANNER */}
                <PageHero 
                    bgImage={savingsHeroBg}
                    kicker="Hisa, Akiba & Amana"
                    heading="Jenga Kesho Yenye Uhakika"
                    paragraph="Wekeza na uweke akiba mahali salama ambapo mtaji wako unazalisha faida kubwa kila mwaka na kukupa nguvu kamili ya umiliki wa ushirika wako."
                />

                {/* 2. CORE SPECIFICATIONS GRID */}
                <section className="py-5 bg-white border-bottom">
                    <div className="container">
                        <div className="row g-4 text-center justify-content-center">
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-4 border-start border-4 border-primary">
                                    <FaAward className="fs-3 text-warning mb-2" />
                                    <h6 className="fw-bold mb-1">Mfalme wa Umiliki</h6>
                                    <span className="text-muted-custom">Hisa zinakupa haki ya kura na mgao wa faida (Dividends).</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-4 border-start border-4 border-warning">
                                    <FaPiggyBank className="fs-3 text-warning mb-2" />
                                    <h6 className="fw-bold mb-1">Dhamana ya Mikopo</h6>
                                    <span className="text-muted-custom">Akiba yako inakuwezesha kukopa hadi mara 3 ya thamani yake.</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-4 border-start border-4 border-success">
                                    <FaShieldAlt className="fs-3 text-success mb-2" />
                                    <h6 className="fw-bold mb-1">Ulinzi wa 100%</h6>
                                    <span className="text-muted-custom">Mifumo salama ya kidijitali kulinda na kukuza amana zako.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. TRIPLE PILLARS DETAILED SECTION */}
                <section className="py-5 bg-light-surface">
                    <div className="container">
                        
                        {/* PILLAR 1: HISA ZA USHIRIKA */}
                        <div className="row align-items-center g-5 mb-5 premium-saving-row">
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-img-wrapper shadow">
                                    <img src={hisaImg} alt="Hisa za Ushirika YCSC" className="img-fluid rounded-4" />
                                    <div className="saving-type-tag">1. Hisa za Ushirika</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-info-content">
                                    <div className="accent-bar mb-3"></div>
                                    <h2 className="saving-title fw-extrabold mb-3">Hisa za Ushirika (Equity Shares)</h2>
                                    <p className="lead text-muted-custom mb-4">
                                        Hisa ndio nguzo kuu ya umiliki wako ndani ya YCSC SACCOS. Kununua na kuongeza hisa zako hakuimarishi tu mtaji wa chama chetu, bali kunakufanya wewe kuwa mmiliki mkuu mwenye sauti.
                                    </p>
                                    <ul className="list-unstyled premium-benefits-list mb-4">
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Mgao wa Faida wa Kila Mwaka:</strong> Unapata gawio zuri (Dividends) kulingana na idadi ya hisa zako kutokana na faida inayopatikana.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Haki ya Maamuzi:</strong> Kila mwanachama mwenye hisa ana haki kamili ya kupiga kura na kuchagua viongozi kwenye Mkutano Mkuu.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* PILLAR 2: AKIBA YA KILA MWEZI */}
                        <div className="row align-items-center g-5 mb-5 premium-saving-row flex-lg-row-reverse">
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-img-wrapper shadow">
                                    <img src={akibaImg} alt="Akiba ya Kila Mwezi YCSC" className="img-fluid rounded-4" />
                                    <div className="saving-type-tag bg-warning-accent">2. Akiba ya Kila Mwezi</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-info-content">
                                    <div className="accent-bar bg-warning mb-3"></div>
                                    <h2 className="saving-title fw-extrabold mb-3">Akiba ya Lazima ya Kila Mwezi</h2>
                                    <p className="lead text-muted-custom mb-4">
                                        Huu ni mfumo wa kujiwekea akiba endelevu kila mwezi unaojenga nidhamu thabiti ya kifedha. Akiba yako ndiyo nguzo kuu inayofungua milango ya wewe kuaminika kiuchumi.
                                    </p>
                                    <ul className="list-unstyled premium-benefits-list mb-4">
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Kigezo Kikuu cha Kukopa:</strong> Akiba yako inatumika kama dhamana ya msingi, kukuwezesha kupata mikopo mikubwa kwa urahisi zaidi.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Ustawi wa Muda Mrefu:</strong> Akiba hii haitolewi hovyo hadi uanachama unapoacha, hivyo inakuhakikishia mfuko thabiti wa baadae.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* PILLAR 3: AMANA MAALUM */}
                        <div className="row align-items-center g-5 premium-saving-row">
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-img-wrapper shadow">
                                    <img src={amanaImg} alt="Amana Maalum YCSC" className="img-fluid rounded-4" />
                                    <div className="saving-type-tag bg-success">3. Amana Maalum (Deposits)</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="saving-detailed-info-content">
                                    <div className="accent-bar bg-success mb-3"></div>
                                    <h2 className="saving-title fw-extrabold mb-3">Amana za Muda na Malengo Maalum</h2>
                                    <p className="lead text-muted mb-4">
                                        Tofauti na akiba ya kila mwezi, Amana (Deposits) ni fedha unazoweka kwa hiari kwa ajili ya kutimiza malengo maalum ya muda mfupi au mrefu au dharura za kifamilia.
                                    </p>
                                    <ul className="list-unstyled premium-benefits-list mb-4">
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Amana za Malengo (Targeted):</strong> Maalum kwa ajili ya maandalizi ya ada za shule za watoto, ununuzi wa viwanja, ujenzi, au likizo.</span>
                                        </li>
                                        <li className="d-flex align-items-start mb-2">
                                            <IoMdCheckmarkCircle className="text-success fs-5 me-2 mt-1 flex-shrink-0" />
                                            <span><strong>Utoaji Rahisi:</strong> Unaweza kutoa amana hizi wakati wowote unapofikia lengo lako au unapokabiliwa na hitaji maalum bila kuathiri sifa yako ya ukopaji.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {/* 4. INVESTMENT CALLOUT SECTION */}
                <section className="py-5 bg-white text-center">
                    <div className="container">
                        <div className="p-4 p-md-5 rounded-4 bg-light-surface border d-flex flex-column align-items-center justify-content-center">
                            <FaChartLine className="fs-1 text-primary mb-3" />
                            <h3 className="fw-bold text-dark mb-2">Anza Uwekezaji Wako Leo</h3>
                            <p className="text-muted max-width-600 mx-auto mb-0">
                                Kila shilingi unayoweka leo ndani ya YCSC SACCOS ni matofali thabiti unayoweka kwenye ukuta wa uhuru wako wa kiuchumi. Wasiliana na uongozi au ingia kwenye mfumo wetu kuanza kuongeza amana zako sasa.
                            </p>
                        </div>
                    </div>
                </section>

                <Footer />

            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading py-5 text-center">
                {getInlineLoader()}
            </div>
        );
    }
}